
    import styled from 'styled-components';
    import * as Copy from 'styles/components/copy';

    export const Content = styled.div`
        display: flex;
        position: relative;
        font-family: CNN Condensed;

        flex-direction: column;
        justify-content: center;
        align-items: center;

        width: 100%;
        margin: 0 auto;

        flex: 1 0 auto;
    `;

    export const Title = styled(Copy.ParagraphElement)`
        display: flex;
        font-weight: 200;
        font-size: 21px;
        text-align: center;
        letter-spacing: 1.15px;
        max-width: 700px;
        
        margin: 0 0;
        padding: 0;

        ${({theme}) => theme.breakpoints['sm']}
        {
            font-size: 28px;
        }

        ${({theme}) => theme.breakpoints['md']}
        {
            font-size: 35px;
            letter-spacing: 2.52px;
        }
    `;

    export const Subhed = styled(Copy.ParagraphElement)`
        max-width: 700px;
        font-size: 14px;
        font-weight: 200;
        letter-spacing: 1.46px;
        text-align: center;
        
        margin: 0 0;
        padding: 0;

        ${({theme}) => theme.breakpoints['md']}
        {
            font-size: 18px;
        }

        ${({theme}) => theme.breakpoints['md']}
        {
            font-size: 21px;
        }
    `;

    export const OptionContainer = styled.div`
        display: flex;
        position: relative;
        flex-direction: column;
        margin: 15px 0 10px;
        width: 100%;
        
        align-items: center;

        .cloud &
        {
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;

            max-width: 550px;
        }

        ${({theme}) => theme.breakpoints['sm']}
        {
            margin: 30px 0 20px;
        }

        ${({theme}) => theme.breakpoints['md']}
        {
            margin: 50px 0 20px;
        }
    `;

    export const OptionLabel = styled(Copy.ParagraphElement)`
        font-family: CNN Condensed;
        font-size: 18px;
        font-weight: 200;
        letter-spacing: 1.3px;
        white-space: nowrap;
        
        margin: 0;
        padding: 0;

        .uppercase &
        {
            text-transform: uppercase;
        }

        .lowercase &
        {
            text-transform: lowercase;
        }

        .cloud &
        {
            font-size: 16px;
        }

        .md_label &
        {
            font-size: 16px;
        }

        .sm_label &
        {
            font-size: 14px;
        }

        ${({theme}) => theme.breakpoints['sm']}
        {
            font-size: 24px;

            .cloud &
            {
                font-size: 16px;
            }

            .md_label &
            {
                font-size: 18px;
            }

            .sm_label &
            {
                font-size: 14px;
            }
        }

        ${({theme}) => theme.breakpoints['md']}
        {
            font-size: 24px;
            letter-spacing: 1.3px;

            .cloud &
            {
                font-size: 18px;
            }

            .md_label &
            {
                font-size: 21px;
            }

            .sm_label &
            {
                font-size: 16px;
            }
        }
    `;

    export const Option = styled.div`
        user-select: none;
        cursor: pointer;
        display: flex;
        position: relative;
        border-radius: 30px;
        background: ${({theme}) => theme.white};
        color: #437079;
        
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 2px 0px;
        width: 350px;
        max-width: 100%;
        
        min-height: 35px;

        margin-bottom: 10px;

        transition: background 500ms, color 500ms;

        .cloud &
        {
            margin-right: 10px;
            padding: 5px 10px;
            width: auto;
            height: auto;
            min-height: unset;
        }

        .disabled &
        {
            cursor: auto;
            pointer-events: none;
            opacity: 0.5;
        }

        &.active
        {
            cursor: pointer;
            pointer-events: auto;

            background: #f1d642;
            color: ${({theme}) => theme.white};
            opacity: 1;
        }
        
        &:last-child
        {
            margin-bottom: 0px;
            margin-right: 0px;

            .cloud &
            {
                margin-bottom: 20px;
                margin-right: 10px;
            }
        }

        ${({theme}) => theme.breakpoints['sm']}
        {
            padding: 5px 0px;
            min-height: 45px;
        }

        ${({theme}) => theme.breakpoints['md']}
        {
            padding: 10px 0px;
            margin-bottom: 20px;
            min-height: unset;
        }
    `;

    export const Instruction = styled(Copy.SpanElement)`

    `;


    export const Submit = styled(Copy.SpanElement)`
        user-select: none;
        pointer-events: none;

        display: flex;
        position: relative;
        border-radius: 20px;
        border: solid 0.5px #979797;
        background-color: #ddf4f6;

        font-size: 16px;
        font-weight: 500;
        color: ${({theme}) => theme.gray7};

        text-transform: lowercase;

        flex-direction: row;
        justify-content: center;
        align-items: center;

        width: 128px;
        height: 31px;
        opacity: 0.75;

        margin: 20px 0;

        transition: color 500ms, opacity 500ms;

        &.enabled
        {
            pointer-events: auto;
            cursor: pointer;
            color: #437079;
            opacity: 1;
        }
    `;